import { render, staticRenderFns } from "./PublicTrainingOld.vue?vue&type=template&id=7a67108a&scoped=true"
import script from "./PublicTrainingOld.vue?vue&type=script&lang=js"
export * from "./PublicTrainingOld.vue?vue&type=script&lang=js"
import style0 from "./PublicTrainingOld.vue?vue&type=style&index=0&id=7a67108a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67108a",
  null
  
)

export default component.exports